import React from "react";
import View from "../../pages/user_profile";
import imageCompression from "browser-image-compression";
import { Box, isWidthDown, withWidth } from "@material-ui/core";
import { Loading } from "../../ui/loader";

class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      src: "",
      date: "",
    };
  }

  onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      let options = {
        maxSizeMB: 0.5,
        maxWidthOrHeight: 192,
        useWebWorker: true,
      };
      this.setState({ name: event.target.value.split(/(\\|\/)/g).pop() });
      imageCompression(event.target.files[0], options).then(
        (compressedFile) => {
          let reader = new FileReader();
          reader.onload = (e) => {
            this.setState({ src: reader.result });
          };
          reader.readAsDataURL(compressedFile);
        }
      );
    } else {
      this.setState({ src: "", name: "" });
    }
  };

  onChangeDate = (date) => {
    this.setState({ date: date });
  };

  componentDidMount() {
    this.props.getUserProfile();
  }

  onUpdateUserProfile = (
    phone,
    country,
    address,
    nick_name,
    first_name,
    last_name,
    date_of_birthday,
    avatar,
    receive_newsletter,
    receive_updates,
    email,
    post_code,
    suburb,
    state,
    license
  ) => {
    this.props.updateUserProfile(
      phone,
      country,
      address,
      nick_name,
      first_name,
      last_name,
      date_of_birthday,
      avatar,
      receive_newsletter,
      receive_updates,
      email,
      post_code || null,
      suburb,
      state,
      license
    );
  };
  userLogout = () => {
    this.props.logout();
  };

  render() {
    const { user, loading } = this.props.user;
    const { date, src } = this.state;
    const { width } = this.props;

    const isSmallScreen = isWidthDown("sm", width);
    const isMdScreen = isWidthDown("md", width);
    if (loading) {
      return <Loading loading={loading} />;
    }
    if (this.props.session) {
      localStorage.setItem("isLogin", true);
    }
    return (
      <Box
        pt={6}
        className={
          isSmallScreen
            ? "smallScreensBorder rightMemberAreaScreen"
            : "threeBordersProfile rightMemberAreaScreen"
        }
      >
        <Box className="fontStyleHeadingProfile" mb={2}>
          Profile
        </Box>
        <View
          date={date}
          imageSrc={src}
          handleImageChange={this.onImageChange}
          handleChangeDate={this.onChangeDate}
          handleUpdateUserProfile={this.onUpdateUserProfile}
          user={user}
          isLoadin={loading}
          isSmallScreen={isSmallScreen}
          isMdScreen={isMdScreen}
          userLogout={this.userLogout}
        />
      </Box>
    );
  }
}

export default withWidth()(Profile);
